
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integracja-ai-w-aplikacji",
      function () {
        return require("private-next-pages/integracja-ai-w-aplikacji.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integracja-ai-w-aplikacji"])
      });
    }
  